import PropTypes from "prop-types"


const properties = {
  verificationRequestCreatedAt: PropTypes.string,
  verificationRequestId: PropTypes.string
}

const EnableMyAccount2FAOutputShapeShape = PropTypes.exact(properties)

export default EnableMyAccount2FAOutputShapeShape
export { properties }
